import React from 'react';
import { useNavigate } from 'react-router-dom';
import img from '../images/Onboarding-dashboard.png';
import img2 from '../images/Slider.png';

const Splash1 = () => {
  const navigate = useNavigate();

  const handleNext = () => navigate('/splash2');
  const handleSkip = () => navigate('/login');

  return (
    <div className='splashnew-container1'>
      <div className='onboarding-dashboard-img'>
        <img src={img} alt="Onboarding Dashboard" />
      </div>
      <div className='onboarding-bg'>
        <div className='onboarding-content'>
          <h3>Personalize your profile</h3>
          <div className='onboarding-img'>
            <img src={img2} alt="Onboarding Slider" />
          </div>
          <div className='onboarding-btn'>
            <div className='onboarding-btn1'>
              <button onClick={handleSkip}>Skip</button>
            </div>
            <div className='onboarding-btn2'>
              <button onClick={handleNext}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Splash1;